import serviciosData from '../data/servicios.json';

class ServiciosService {
    constructor() {
        this.servicios = serviciosData;
    }

    getInstituciones() {
        return this.servicios.instituciones;
    }

    getTramitesPorInstitucion(institucionNombre) {
        const institucion = this.servicios.instituciones.find(
            inst => inst.nombre === institucionNombre
        );
        return institucion ? institucion.tramites : [];
    }
}

export default new ServiciosService(); 